module.exports = __webpack_public_path__ + "static/media/art-completed.07d5cf6b.svg";